export const analyticsId = {
  DISPLAY_MODAL: 'DISPLAY_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  CANCEL_LINK: 'CANCEL_LINK',
  CONTINUE_BUTTON: 'CONTINUE_BUTTON',
  DISPLAY_LEAVE_MODAL: 'DISPLAY_LEAVE_MODAL',
  CLOSE_LEAVE_MODAL: 'CLOSE_LEAVE_MODAL',
  LEFT_LEAVE_LINK: 'LEFT_LEAVE_LINK',
  RIGHT_LEAVE_BUTTON: 'RIGHT_LEAVE_BUTTON',
};

export const catalogue = {
  [analyticsId.DISPLAY_MODAL]: () => ({
    categoriaEvento: 'modal no migracion',
    accionEvento: 'vista',
    action: 'open',
    format: 'modal',
    component: 'modal/noMigration',
    element: 'full',
  }),
  [analyticsId.CLOSE_MODAL]: () => ({
    categoriaEvento: 'modal no migracion',
    accionEvento: 'cerrar',
    action: 'close',
    format: 'cross',
    component: 'modal/noMigration',
    element: 'cross',
  }),
  [analyticsId.CANCEL_LINK]: () => ({
    categoriaEvento: 'modal no migracion',
    accionEvento: 'cancelar productos y no migrar',
    action: 'click',
    format: 'link',
    component: 'modal/noMigration',
    element: 'cancelProductsAndNotMigrate',
  }),
  [analyticsId.CONTINUE_BUTTON]: () => ({
    categoriaEvento: 'modal no migracion',
    accionEvento: 'migrar y disfrutar productos',
    action: 'click',
    format: 'button',
    component: 'modal/noMigration',
    element: 'migrateAndEnjoyProducts',
  }),
  [analyticsId.DISPLAY_LEAVE_MODAL]: () => ({
    categoriaEvento: 'modal abandonar migracion',
    accionEvento: 'vista',
    action: 'open',
    format: 'modal',
    component: 'modal/leaveMigration',
    element: 'full',
  }),
  [analyticsId.CLOSE_LEAVE_MODAL]: () => ({
    categoriaEvento: 'modal abandonar migracion',
    accionEvento: 'cerrar',
    action: 'close',
    format: 'cross',
    component: 'modal/leaveMigration',
    element: 'cross',
  }),
  [analyticsId.LEFT_LEAVE_LINK]: () => ({
    categoriaEvento: 'modal abandonar migracion',
    accionEvento: 'no',
    action: 'click',
    format: 'button',
    component: 'modal/leaveMigration',
    element: 'no',
  }),
  [analyticsId.RIGHT_LEAVE_BUTTON]: () => ({
    categoriaEvento: 'modal abandonar migracion',
    accionEvento: 'si salir',
    action: 'click',
    format: 'button',
    component: 'modal/leaveMigration',
    element: 'yesExit',
  }),
};
